import { observable } from "mobx";
import ChargeNotificationPreferencesChangeRejectionReason from "./chargeNotificationPreferencesChangeRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class NotificationPreferencesChangePermittedActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: ChargeNotificationPreferencesChangeRejectionReason;
}
